import React from 'react';
import Content from 'src/components/Content';
import { Grid } from '@material-ui/core';
import EngagementsLedgerCard from 'src/views/shared/EngagementsLedgerCard';
import Activities from 'src/views/shared/Activities';
import TasksCard from '../shared/TasksCard';

function Dashboard() {
  return (
    <Content title="Dashboard" maxWidth="lg">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EngagementsLedgerCard
            title="Recently visited engagements"
            url="/automatic/recently-visited-engagements/"
          />
        </Grid>
        <Grid item xs={12}>
          <TasksCard
            title="Outstanding tasks"
            url="/automatic/tasks-for-team/"
            seeAllRoute="/tasks"
          />
        </Grid>
        <Grid item xs={12}>
          <Activities title="Events" url="/automatic/events/" includeEngagementName />
        </Grid>
      </Grid>
    </Content>
  );
}

export default Dashboard;
